'use strict';

angular.module('mobile-apps')
  .factory('FilesLanguageEntries', ['$resource',
    function($resource) {
        return $resource('v1/projects/:mobileAppId/languages/:languageId/entries/:entryId/images');
    }
])

  .factory('FilesMobileApps', ['$resource',
     function($resource) {
       return $resource('v1/projects/:mobileAppId/images/:fileId');
     }
]);
